import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

export default function Feedback({ url }) {
  return (
    <Link
      to={url}
      className="btn btn-light btn-reverse ms-3 mb-3 mb-lg-0 step-action-btn"
    >
      Feedback
    </Link>
  );
}

Feedback.propTypes = {
  url: PropTypes.string.isRequired,
};
